<div class="dialog-header">
    <span>{{ data.title }}</span>
    <button mat-icon-button [mat-dialog-close]="false">
        <vulcan-icon icon="x"></vulcan-icon>
    </button>
</div>

<mat-dialog-content>
    <vulcan-date-time-picker [config]="data.config" [dateForm]="data.form"></vulcan-date-time-picker>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
    <button mat-flat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="data.form.invalid" [mat-dialog-close]="true">Submit</button>
</mat-dialog-actions>
